var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',{class:_vm.vclass},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.markRequired)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }